<template>
<div class="chapter">
<div class="inner_page">
<p class="imagest" id="frontispiece"><img alt="image" src="images/1_frontis_battleofatlan_fmt.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontispiece.vue?017d1e84